/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { organizationsUpdate } from "../../funcs/organizationsUpdate.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request:
    operations
      .PutApiLeadScraperMicroserviceApiV1OrganizationRequestBody$inboundSchema,
};

export const tool$organizationsUpdate: ToolDefinition<typeof args> = {
  name: "organizations_update",
  description: `Update organization details

Updates the configuration of a specific organization`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await organizationsUpdate(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
